/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/
// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

// Components
import { Col } from '../../../../../../layout/elements/Col';
import { StatusIndicatorProps } from '../../../../../../layout/elements/StatusIndicator';

const speedometerContainerStyle: string = `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0 1.25rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.5rem 0 2rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 2rem 0 2.75rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    width: calc(100% + 2px);
  };
`;

export const OverallStatusContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.motorStatus.borderColor};
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1rem 1.5rem;
  };
`;

export const OverallContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.color.crusherDashboard.motorStatus.borderColor};
  border-radius: 4px;
`;

export const RPMMotorSpeedometer = styled.div`
  ${speedometerContainerStyle};
  border-right: 1px solid ${({ theme }) => theme.color.crusherDashboard.motorStatus.borderColor};
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.motorStatus.borderColor};
`;

export const MotorCurrentSpeedometer = styled.div`
  ${speedometerContainerStyle};
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.motorStatus.borderColor};
`;

export const CounterShaftVibrationTitle = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.motorStatus.borderColor};
`;

export const ThermometersContainer = styled.div<{ hasVibrationSensorsEnabled: boolean }>`
  justify-content: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.motorStatus.borderColor};
  padding: 1rem 0 1.25rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.5rem 0 2rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 2rem 0 2.75rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    border-right: ${({ hasVibrationSensorsEnabled, theme }) => (
      hasVibrationSensorsEnabled
        ? `1px solid ${theme.color.crusherDashboard.motorStatus.borderColor}`
        : 'none'
    )};
  };
`;

export const VibrationTitleContainer = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.motorStatus.borderColor};
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1rem 1.5rem;
  };
`;

export const VibrationSensorsContainer = styled(Col)`
  min-height: 100%;
  flex: 1;
`;

export const VibrationSensorsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const VibrationSensorItem = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.motorStatus.borderColor};
  padding: 0.75rem 1rem;
  align-content: center;
  flex: 1;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1rem 1.5rem;
  };
`;

export const OverallPermissiveContainer = styled.div`
  padding: 1.375rem 1.25rem 0.625rem 1.25rem;
`;

export const CrusherStartListDescription = styled.div<Pick<StatusIndicatorProps, 'status'>>`
  padding: 12px 20px;
  gap: 2px;
  width: 100%;
  background-color: ${({ status, theme }) => (
    status === 'alarm'
      ? theme.color.crusherDashboard.motorStatus.descriptionListErrorBackgroundColor
      : 'transparent'
  )};
  border-radius: ${({ status }) => (
    status === 'alarm'
      ? '4px'
      : 'none'
  )};
`;

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  background-color: ${({
    theme,
  }) => theme.color.crusherDashboard.motorStatus.footerBackgroundColor};
  width: 100%;
  padding: 0.75rem 1rem;
  margin-top: 0.75rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
    margin-top: 1rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1rem 1.5rem;
    margin-top: 1.25rem;
  };
`;
